import { render, staticRenderFns } from "./RewardAttachments.vue?vue&type=template&id=a2bdec9e&"
import script from "./RewardAttachments.vue?vue&type=script&lang=js&"
export * from "./RewardAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports